import { connect } from 'react-redux';
import {
  isDownloadingImage,
  isLoadingImages,
  isLoadingSecondaryImages,
  isLoadingImageUrl,
} from 'core/selectors';
import { downloadImage } from 'core/slices/imageDownload';
import Canvas from '../../../components/visualizer/Canvas';

export default connect(
  state => ({
    isLoadingImages: isLoadingImages(state),
    isLoadingImageUrl: isLoadingImageUrl(state),
    isLoadingSecondaryImages: isLoadingSecondaryImages(state),
    isDownloadingImage: isDownloadingImage(state),
  }),
  { downloadImage },
)(Canvas);
